module.exports = __webpack_public_path__ + "img/bullet.257ee69e.png";